import {ClientLatencyTools} from '@packages/systems/designer/performance-tools';
import {TelemetryEventLabel} from '@packages/systems/designer-telemetry';
import {actionTypes as unitInputActionTypes} from '@packages/systems/design-system/WebflowUnitInput';

const LABEL = TelemetryEventLabel.CANVAS_EDIT_TO_RENDER_LATENCY;

export type EditType = 'drag' | 'resize';

const RESIZE_COMMIT_ACTIONS: ReadonlySet<string> = new Set([
  unitInputActionTypes.INPUT_ENTER_KEY_PRESSED,
  unitInputActionTypes.INPUT_BLURRED,
  unitInputActionTypes.INPUT_DRAG_ENDED,
  unitInputActionTypes.INPUT_WHEEL_ENDED,
  unitInputActionTypes.INPUT_ARROW_UP_KEY_PRESSED,
  unitInputActionTypes.INPUT_ARROW_DOWN_KEY_PRESSED,
  unitInputActionTypes.INPUT_RIGHT_UP_TICK_CLICKED,
  unitInputActionTypes.INPUT_RIGHT_DOWN_TICK_CLICKED,
  unitInputActionTypes.SELECT_MENU_UNIT_CHANGED,
]);

export const isResizeCommit = (
  meta: Readonly<Record<string, unknown>> | undefined
): boolean => {
  const actionType = meta?.type;
  return (
    typeof actionType === 'string' && RESIZE_COMMIT_ACTIONS.has(actionType)
  );
};

export const startEditToRenderMeasurement = (editType: EditType): void => {
  ClientLatencyTools.cancel(LABEL);
  ClientLatencyTools.start(LABEL, {editType});
};

export const cancelEditToRenderMeasurement = (): void => {
  ClientLatencyTools.cancel(LABEL);
};

export const finishEditToRenderMeasurement = (): void => {
  ClientLatencyTools.finishAndReport(LABEL);
};
